export const CREATE_HUBSPOT_CONNECTION_REQUEST = "CREATE_HUBSPOT_CONNECTION_REQUEST";
export const CREATE_HUBSPOT_CONNECTION_SUCCESS = "CREATE_HUBSPOT_CONNECTION_SUCCESS";
export const CREATE_HUBSPOT_CONNECTION_FAILURE = "CREATE_HUBSPOT_CONNECTION_FAILURE";

export const START_HUBSPOT_OAUTH_REQUEST = "START_HUBSPOT_OAUTH_REQUEST";
export const START_HUBSPOT_OAUTH_SUCCESS = "START_HUBSPOT_OAUTH_SUCCESS";
export const START_HUBSPOT_OAUTH_FAILURE = "START_HUBSPOT_OAUTH_FAILURE";

export const GET_HUBSPOT_CONNECTION_REQUEST = "GET_HUBSPOT_CONNECTION_REQUEST";
export const GET_HUBSPOT_CONNECTION_SUCCESS = "GET_HUBSPOT_CONNECTION_SUCCESS";
export const GET_HUBSPOT_CONNECTION_FAILURE = "GET_HUBSPOT_CONNECTION_FAILURE";

export const UPDATE_HUBSPOT_CONNECTION_REQUEST = "UPDATE_HUBSPOT_CONNECTION_REQUEST";
export const UPDATE_HUBSPOT_CONNECTION_SUCCESS = "UPDATE_HUBSPOT_CONNECTION_SUCCESS";
export const UPDATE_HUBSPOT_CONNECTION_FAILURE = "UPDATE_HUBSPOT_CONNECTION_FAILURE";

export const DELETE_HUBSPOT_CONNECTION_REQUEST = "DELETE_HUBSPOT_CONNECTION_REQUEST";
export const DELETE_HUBSPOT_CONNECTION_SUCCESS = "DELETE_HUBSPOT_CONNECTION_SUCCESS";
export const DELETE_HUBSPOT_CONNECTION_FAILURE = "DELETE_HUBSPOT_CONNECTION_FAILURE";

export const GET_HUBSPOT_OBJECTS_REQUEST = "GET_HUBSPOT_OBJECTS_REQUEST";
export const GET_HUBSPOT_OBJECTS_SUCCESS = "GET_HUBSPOT_OBJECTS_SUCCESS";
export const GET_HUBSPOT_OBJECTS_FAILURE = "GET_HUBSPOT_OBJECTS_FAILURE";

export const GET_HUBSPOT_OBJECT_DESCRIBE_REQUEST = "GET_HUBSPOT_OBJECT_DESCRIBE_REQUEST";
export const GET_HUBSPOT_OBJECT_DESCRIBE_SUCCESS = "GET_HUBSPOT_OBJECT_DESCRIBE_SUCCESS";
export const GET_HUBSPOT_OBJECT_DESCRIBE_FAILURE = "GET_HUBSPOT_OBJECT_DESCRIBE_FAILURE";

export const GET_HUBSPOT_OBJECT_PREVIEW_REQUEST = "GET_HUBSPOT_OBJECT_PREVIEW_REQUEST";
export const GET_HUBSPOT_OBJECT_PREVIEW_SUCCESS = "GET_HUBSPOT_OBJECT_PREVIEW_SUCCESS";
export const GET_HUBSPOT_OBJECT_PREVIEW_FAILURE = "GET_HUBSPOT_OBJECT_PREVIEW_FAILURE";

export const createHubspotConnectionRequest = (connection) => ({
    type: CREATE_HUBSPOT_CONNECTION_REQUEST,
    params: {
        connection
    }
});

export const createHubspotConnectionSuccess = (connection) => ({
    type: CREATE_HUBSPOT_CONNECTION_SUCCESS,
    payload: {
        connection
    }
});

export const createHubspotConnectionFailure = (error) => ({
    type: CREATE_HUBSPOT_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const startHubspotOAuthRequest = (connectionId, returnUrl) => ({
    type: START_HUBSPOT_OAUTH_REQUEST,
    params: {
        connectionId,
        returnUrl
    }
});

export const startHubspotOAuthSuccess = (result) => ({
    type: START_HUBSPOT_OAUTH_SUCCESS,
    payload: {
        result
    }
});

export const startHubspotOAuthFailure = (error) => ({
    type: START_HUBSPOT_OAUTH_FAILURE,
    payload: {
        error
    }
});

export const getHubspotConnectionRequest = (connectionId) => ({
    type: GET_HUBSPOT_CONNECTION_REQUEST,
    params: {
        connectionId
    }
});

export const getHubspotConnectionSuccess = (connection) => ({
    type: GET_HUBSPOT_CONNECTION_SUCCESS,
    payload: {
        connection
    }
});

export const getHubspotConnectionFailure = (error) => ({
    type: GET_HUBSPOT_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const updateHubspotConnectionRequest = (connectionId, updatedConnection) => ({
    type: UPDATE_HUBSPOT_CONNECTION_REQUEST,
    params: {
        connectionId,
        updatedConnection
    }
});

export const updateHubspotConnectionSuccess = (connection) => ({
    type: UPDATE_HUBSPOT_CONNECTION_SUCCESS,
    payload: {
        connection
    }
});

export const updateHubspotConnectionFailure = (error) => ({
    type: UPDATE_HUBSPOT_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const deleteHubspotConnectionRequest = (connectionId) => ({
    type: DELETE_HUBSPOT_CONNECTION_REQUEST,
    params: {
        connectionId
    }
});

export const deleteHubspotConnectionSuccess = (connectionId) => ({
    type: DELETE_HUBSPOT_CONNECTION_SUCCESS,
    payload: {
        connectionId
    }
});

export const deleteHubspotConnectionFailure = (error) => ({
    type: DELETE_HUBSPOT_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const getHubspotObjectsRequest = (connectionId) => ({
    type: GET_HUBSPOT_OBJECTS_REQUEST,
    params: {
        connectionId
    }
});

export const getHubspotObjectsSuccess = (objects) => ({
    type: GET_HUBSPOT_OBJECTS_SUCCESS,
    payload: {
        objects
    }
});

export const getHubspotObjectsFailure = (error) => ({
    type: GET_HUBSPOT_OBJECTS_FAILURE,
    payload: {
        error
    }
});

export const getHubspotObjectDescribeRequest = (connectionId, objectName) => ({
    type: GET_HUBSPOT_OBJECT_DESCRIBE_REQUEST,
    params: {
        connectionId,
        objectName
    }
});

export const getHubspotObjectDescribeSuccess = (describe) => ({
    type: GET_HUBSPOT_OBJECT_DESCRIBE_SUCCESS,
    payload: {
        describe
    }
});

export const getHubspotObjectDescribeFailure = (error) => ({
    type: GET_HUBSPOT_OBJECT_DESCRIBE_FAILURE,
    payload: {
        error
    }
});

export const getHubspotObjectPreviewRequest = (connectionId, objectName, fields, limit = 10) => ({
    type: GET_HUBSPOT_OBJECT_PREVIEW_REQUEST,
    params: {
        connectionId,
        objectName,
        fields,
        limit
    }
});

export const getHubspotObjectPreviewSuccess = (preview) => ({
    type: GET_HUBSPOT_OBJECT_PREVIEW_SUCCESS,
    payload: {
        preview
    }
});

export const getHubspotObjectPreviewFailure = (error) => ({
    type: GET_HUBSPOT_OBJECT_PREVIEW_FAILURE,
    payload: {
        error
    }
});
